import React from "react";
import { styled } from "styled-components";

function FileComments({ data }) {
    return (
        <div>
            {data.map((comment, index) => (
                <CommentCard key={index}>
                    <CommentHeader>
                        <UserName>{comment.userName}</UserName>
                        <AuthLevel>{comment.authLevelName}</AuthLevel>
                    </CommentHeader>
                    <CommentText>{comment.checkerComments}</CommentText>
                    <CommentDate>{comment.commentDate}</CommentDate>
                </CommentCard>
            ))}
        </div>
    );
}

const CommentCard = styled.div`
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    padding: 15px;
    margin: 10px 0;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
`;

const CommentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;

const UserName = styled.span`
    font-weight: bold;
`;

const AuthLevel = styled.span`
    color: #007bff;
    font-weight: bold;
`;

const CommentText = styled.p`
    margin: 10px 0;
`;

const CommentDate = styled.span`
    font-size: 0.8em;
    color: #888;
`;

export default FileComments;
